import { FiltersState } from '../../interface/interface';

export const revertBulkEmailState = (
  setFilters: React.Dispatch<React.SetStateAction<FiltersState | undefined>>,
  setCurrentStep: React.Dispatch<React.SetStateAction<number>>,
) => {
  setFilters(undefined);
  setCurrentStep(0);
};
